export default "__VITE_ASSET__vwveP4$y__"